import * as React from 'react';

// API
import apibridge from '../../apibridge';

// PACKAGES
import { Link } from 'react-router-dom';
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// UTILS
import { validationErrorsToString } from '../../utils';

// COMPONENTS
import StatusIcon from '../../components/StatusIcon';
import LoadingSpinner from '../../components/LoadingSpinner';

// TYPES
import { SafetyChecklistTemplatesTemplate } from '../../api/models';

const SafetyChecklistsNewChecklist: React.FC = () => {
	// Error and Loading state
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');

	const [isLoading, setIsLoading] = React.useState<boolean>(true);

	// Set up Data state
	const [safetyChecklistsTemplatesData, setSafetyChecklistsTemplatesData] = React.useState<
		SafetyChecklistTemplatesTemplate[]
	>([]);

	const getSafetyChecklistsTemplatesData = async () => {
		setIsLoading(true);

		const response = await apibridge.getSafetyChecklistsTemplates();

		if (response.isError) {
			setIsLoading(false);

			setFormErrorMessage(
				response.validationErrors.length
					? validationErrorsToString(response.validationErrors)
					: response.message || 'An error has occurred'
			);
		} else {
			setIsLoading(false);

			setSafetyChecklistsTemplatesData(response.result || []);
		}
	};

	React.useEffect(() => {
		getSafetyChecklistsTemplatesData();
	}, []);

	const [createOption, setCreateOption] = React.useState<String>('new');

	return (
		<div className="page-general-layout">
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								<div className="general-divider"></div>

								<p className="sub-grey-text mbtom-24">To begin, select from the following option...</p>

								<div className="general-radio-row mbtom-24">
									<input
										type="radio"
										name="createOption"
										checked={createOption === 'new'}
										onChange={() => setCreateOption('new')}
									/>

									<div className="option-info">
										<label htmlFor="createOption">Create an entirely new checklist</label>

										<p className="info-sub">Create a brand new checklist to suit your needs.</p>
									</div>
								</div>

								<div className="general-radio-row mbtom-24">
									<input
										type="radio"
										name="createOption"
										checked={createOption === 'templates'}
										onChange={() => setCreateOption('templates')}
										disabled={safetyChecklistsTemplatesData.length <= 0}
									/>

									<div className="option-info">
										<label htmlFor="createOption">Customise a checklist template</label>

										<p className="info-sub">
											Choose from our menu of checklist templates and customise for your needs.
										</p>
									</div>
								</div>

								<div className="general-divider mbtom-0"></div>

								{createOption === 'templates' &&
									safetyChecklistsTemplatesData &&
									safetyChecklistsTemplatesData.length > 0 && (
										<section className="info-section complaints-page">
											{safetyChecklistsTemplatesData.map((item) => {
												return (
													<div key={item.checklistId || item.templateId} className="row-container">
														<div className="row detail-row">
															<div className="col-auto pdl-0 pdr-0">
																<StatusIcon statusType="document" />
															</div>

															<div className="col-md-auto full-width">
																<div className="row detail-info">
																	<div className="col-12 detail-name">{item.title}</div>
																</div>
															</div>

															<div className="col-auto pdr-0 link-group wide">
																<Link
																	className="btn-text dark-text"
																	to={{
																		pathname: `/preview-checklist/${
																			item.templateId ? 'TemplateId=' + item.templateId : ''
																		}${item.checklistId ? 'ChecklistId=' + item.checklistId : ''}`
																	}}
																>
																	Preview
																</Link>

																<Link
																	className="btn-text"
																	to={{
																		pathname: `/create-checklist/${
																			item.templateId ? 'TemplateId=' + item.templateId : ''
																		}${item.checklistId ? 'ChecklistId=' + item.checklistId : ''}`,
																		state: { fromTemplate: true }
																	}}
																>
																	Use checklist
																</Link>
															</div>
														</div>
													</div>
												);
											})}
										</section>
									)}

								{createOption === 'new' && (
									<div className="single-btn-right-container">
										<Link className="btn-primary" to="/create-checklist">
											Continue
										</Link>
									</div>
								)}
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</div>
	);
};

export default SafetyChecklistsNewChecklist;
